import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Layout } from 'antd';
import axios from 'axios';
import UserPage from 'pages/user_page';
import OuTree from 'component/tree_componenet/outree';
import TopNavBar from 'component/top_navbar/TopNavBar';
import AdminTree from 'component/tree_componenet/adminTree';
import { Logo, SideNavBarWarp, StyledSider } from './style';
import AdminNavBar from 'component/admin_navbar_component';
import UserPageSidebar from 'component/userPage_Sidebar';
import { logout, validateToken } from 'redux/slices/authSlice';
import { setupGetLicenseDetails, setupStatus } from 'redux/slices/setupSlice';
import InterfaceModal from './interface_modal';
import { LoaderComponent } from 'component/loader_component/style';
import Loader from 'component/loader_component';
import Cookies from 'js-cookie';
import { resetDomainState } from 'redux/slices/selectedNodeSlice';
import { resetsingleUserData, setSelectedItems } from 'redux/slices/userSlice';
import { resetTreeState } from 'redux/slices/treedata';
import { resetOuTreeState } from 'redux/slices/ouAdminTree';
import { setLicenseStatus } from 'redux/slices/licenseSlice';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { setGroupSelectedItems } from 'redux/slices/getOuGroups';

const { Header } = Layout;

export default function Interface() {
  const role = localStorage.getItem('role');
  const [modalopen, setModalOpen] = useState(false);
  const [changemodal, setChangemodal] = useState(false);
  const [loading, setloading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { licenseDetails } = useSelector((state) => state.licenseSlice);
  const trialSticky =
    licenseDetails?.isTrial && licenseDetails?.isActived
      ? {
          position: 'sticky',
          zIndex: 2,
          top: 0,
        }
      : {};

  useEffect(() => {
    let timeout;
    const fetchData = async () => {
      const setupStatusValue = await dispatch(setupStatus());
      const licenseStatus = await dispatch(setupGetLicenseDetails());
      dispatch(setLicenseStatus(licenseStatus?.payload));
      if (setupStatusValue?.payload.data.domainstatus && setupStatusValue?.payload.data.groupstatus) {
        if (licenseStatus?.payload?.isActived === true || licenseStatus?.payload?.isActived === false) {
          if (Cookies.get('access_token')) {
            const tokenStatus = await dispatch(validateToken());
            if (tokenStatus.payload && tokenStatus.payload.isExpired) {
              await dispatch(logout());
              dispatch(setSelectedItems([]));
              dispatch(setGroupSelectedItems([]));
              dispatch(resetDomainState());
              dispatch(resetsingleUserData());
              dispatch(resetTreeState());
              dispatch(resetOuTreeState());
              navigate('/login');
            } else {
              timeout = setTimeout(() => {
                setloading(false);
              }, 1000);
            }
          } else {
            timeout = setTimeout(() => {
              navigate('/login');
            }, 500);
          }
        } else {
          dispatch(logout());
          localStorage.clear();
          navigate('/setup');
        }
      } else if (!setupStatusValue?.payload.data.groupstatus) {
        dispatch(logout());
        localStorage.clear();
        navigate('/setup');
      } else {
        timeout = setTimeout(() => {
          dispatch(logout());
          localStorage.clear();
          navigate('/setup');
        }, 1000);
      }
      return () => clearTimeout(timeout);
    };

    fetchData();
  }, []);

  if (location.pathname !== '/license') {
    if (licenseDetails?.isActived === false) {
      navigate('/license');
    }
  }

  // Response interceptor
  axios.interceptors.response.use(
    function (response) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get('access_token');
      return response;
    },
    (error) => {
      if (error && error.response && error.response.status === 401) {
        setModalOpen(true);
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get('access_token');
      return Promise.reject(error);
    }
  );

  return (
    <div className='body-content'>
      {loading ? (
        <>
          <LoaderComponent>
            <Loader />
          </LoaderComponent>
          {/* <InterfaceModal modalopen={modalopen} setModalOpen={setModalOpen} /> */}
        </>
      ) : (
        <Layout className='af-interface-parentlayout'>
          <InterfaceModal modalopen={modalopen} setModalOpen={setModalOpen} />

          {role === 'user' ? (
            <Layout className='layout af-interface-userlayout'>
              <StyledSider width={250} breakpoint='lg' collapsedWidth='0' className='af-interface-user-sidebar'>
                <UserPageSidebar changemodal={changemodal} setChangemodal={setChangemodal} />
              </StyledSider>
              <Layout
                style={{
                  backgroundColor: 'inherit',
                }}
                className='af-interface-user-sublayout'
              >
                <Header
                  style={{
                    backgroundColor: 'inherit',
                    ...trialSticky,
                  }}
                  className='af-interface-user-header'
                >
                  <div style={{ marginRight: '25px' }} className='af-interface-user-topbar-wrap'>
                    <TopNavBar
                      licenseDetails={licenseDetails}
                      changemodal={changemodal}
                      setChangemodal={setChangemodal}
                    />
                  </div>
                  <Divider style={{ margin: '10px 0' }} className='af-interface-user-divider' />
                </Header>
                <UserPage />
              </Layout>
            </Layout>
          ) : (
            <Layout className='layout af-interface-adminlayout'>
              <StyledSider width={250} breakpoint='lg' collapsedWidth='0' className='af-interface-admin-sidebar'>
                <SideNavBarWarp className='af-interface-admin-side-navbar'>
                  <div style={{ flex: '0 1 88%', paddingLeft: '10px' }} className='af-interface-admin-side-wrap'>
                    <div style={{ textAlign: 'center' }} className='af-interface-admin-side-logowrap'>
                      <Logo
                        onClick={licenseDetails?.isActived ? () => navigate('/') : null}
                        className='af-interface-admin-side-logo'
                      />
                    </div>

                    {licenseDetails?.isActived === false ? (
                      <AdminNavBar />
                    ) : /\/adminpage|email_template|create_domain|settings|license|themes|customize_theme|email_delivery|endpoints|brandings|api_settings/.test(
                        location.pathname
                      ) ? (
                      <>
                        <AdminNavBar />
                        <div
                          style={{ textAlign: 'center', marginTop: '10px', marginRight: '10px', paddingRight: '10px' }}
                          className='af-interface-admin-side-dash-button-wrap'
                        >
                          <StyledButton
                            type='primary'
                            onClick={() => {
                              navigate('/');
                            }}
                            style={{ padding: '5px 25px 5px 20px' }}
                            className='af-interface-admin-side-dash-button'
                          >
                            {'<< Dashboard'}
                          </StyledButton>
                        </div>
                      </>
                    ) : role === 'ouadmin' ? (
                      <OuTree />
                    ) : (
                      <AdminTree />
                    )}
                  </div>
                  <div style={{ flex: '0 1 10%' }} className='af-interface-admin-side-version-wrap'>
                    {/\/adminpage|email_template|create_domain|settings|license|themes|customize_theme|email_delivery|endpoints|brandings|api_settings/.test(
                      location.pathname
                    ) && (
                      <div
                        style={{ textAlign: 'center', marginRight: '10px', color: '#bbbbbb' }}
                        className='af-interface-admin-side-version'
                      >
                        <p className='af-interface-admin-side-v-num'>Version {window.globalConfig?.APP_VERSION || '3.7'}</p>
                        <p className='af-interface-admin-side-v-company'>
                          Product By
                          <br />
                          Dart Innovations
                        </p>
                      </div>
                    )}
                  </div>
                </SideNavBarWarp>
              </StyledSider>
              <Layout
                style={{
                  backgroundColor: 'inherit',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                className='af-interface-admin-side-layout'
              >
                <Header
                  style={{
                    backgroundColor: 'inherit',
                    height: '65px',
                    ...trialSticky,
                  }}
                  className='af-interface-admin-side-header'
                >
                  <TopNavBar
                    licenseDetails={licenseDetails}
                    changemodal={changemodal}
                    setChangemodal={setChangemodal}
                  />
                </Header>
                <Outlet />
              </Layout>
            </Layout>
          )}
        </Layout>
      )}
    </div>
  );
}
